const releaseTimeHolders = document.querySelectorAll('.ReleaseTimer');

if (releaseTimeHolders != undefined)
{
    for (let i = 0; i < releaseTimeHolders.length; i++)
    {
        const dateString = releaseTimeHolders[i].dataset.date.replace(' ', 'T');
        const countDownDate = new Date(dateString).getTime();

        if (dateString) {

            const timer = setInterval(function() {

            var now = new Date().getTime();
            var release = countDownDate - now;

            var days = Math.floor(release / (1000 * 60 * 60 * 24));
            var hours = Math.floor((release % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((release % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((release % (1000 * 60)) / 1000);

            //${seconds}s
            releaseTimeHolders[i].innerHTML = `${days}d ${hours}h ${minutes}m`;

            if (release < 0) {
                clearInterval(timer);
                releaseTimeHolders[i].innerHTML = "NEW RELEASE!";
            }

            }, 1000);

        }
    }
}